<template>
      <fiche-header :ressource="ressource"
                    @back="back"
                    @openAll="openAll"
                    @closeAll="closeAll">
      </fiche-header>
  <div class="fiche">
    <!-- Liste des sections de la fiche -->
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('VIREMENT_DELIVERY_LIST')">
        <slot name="section-virement-delivery-list">
          <section-virement-delivery-list ref="VIREMENT_DELIVERY_LIST"
                                          id="VIREMENT_DELIVERY_LIST"
                                          :extended="isExtended('VIREMENT_DELIVERY_LIST')"
                                          :showButton="true"
                                          :autoSave="true"
                                          :readOnly="readOnly"
                                          :moduleId="moduleId"
                                          :searchText="searchText"
                                          :ressourceHeader="ressource"
                                          :fiche="fiche"
                                          :delivery=selectedDelivery
                                          :route="route"
                                          :attribut="attribut"
                                          @extended="setExtended"
                                          @fullscreen="setFullscreen"
                                          @status="updateStatus"
                                          @toggleCardView="toggleCardView"
                                          @updated="deliveryUpdated"
                                          @selectItem = "selectItem">
          </section-virement-delivery-list>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('VIREMENT_DELIVERY_DETAIL')">
        <slot name="section-virement-delivery-detail">
          <section-virement-delivery-detail ref="VIREMENT_DELIVERY_DETAIL"
                                            id="VIREMENT_DELIVERY_DETAIL"
                                            :extended="isExtended('VIREMENT_DELIVERY_DETAIL')"
                                            :showButton="true"
                                            :autoSave="true"
                                            :readOnly="readOnly"
                                            :moduleId="moduleId"
                                            :searchText="searchText"
                                            :ressourceHeader="ressource"
                                            :fiche="fiche"
                                            :delivery=selectedDelivery
                                            :route="route"
                                            :attribut="attribut"
                                            @extended="setExtended"
                                            @fullscreen="setFullscreen"
                                            @status="updateStatus"
                                            @toggleCardView="toggleCardView"
                                            @updated="transactionUpdated"
                                            @selectItem = "selectItem">
          </section-virement-delivery-detail>
        </slot>
    </v-col>
  </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from "vue";
import FicheBase from '@/framework/base/components/FicheBase';
import Route from '@/extend/classes/Route';
import { CiRouter } from '@/framework/base/helpers/NavHelper'
import { Fiches } from '@/generated/classes/AppSchema';
import { Extended } from '@/framework/base/classes/Schema';
import Delivery from '@/extend/classes/Delivery';
import Transaction from '@/extend/classes/Transaction';
import { storeTransaction } from '@/generated/stores';
import FicheHeader from '@/framework/base/components/FicheHeader.vue';
import { GenFiche, RessourceGenFiche } from '@/generated/ressources/generatedRessources';
import SectionVirementDeliveryList from '@/extend/sections/SectionVirementDeliveryListExtend.vue';
import SectionVirementDeliveryDetail from '@/extend/sections/SectionVirementDeliveryDetailExtend.vue';

export default defineComponent({
  extends: FicheBase,
  components: {
    SectionVirementDeliveryList,
    SectionVirementDeliveryDetail,
    FicheHeader,
  },

  props: {
    delivery: {
      type: Object as PropType<Delivery>,
    },
  },

  created (): void {
    this.addFiches(this.sections);
  },

  data() {
    return {
      moduleId: 0,
      fiche: Fiches.VIREMENTS_EMIS,
      sections: [
        'VIREMENT_DELIVERY_LIST',
        'VIREMENT_DELIVERY_DETAIL',
      ],

      transaction: new Transaction(),
    }
  },

  computed: {
    ressource () {
      return RessourceGenFiche(GenFiche.FICHE_VIREMENTS_EMIS);
    },

    selectedDelivery (): Delivery {
      return this.delivery
    },
  },
  methods: {
    ficheMounted () {
      this.onShowSectionChanged();
      this.setFocus();
    },

    setFocus (): void {
      if (this.isMounted) {
        let res = false;
        let first = '';
        const route = CiRouter.getRoute();
        const notifSection = route ? route.section : '';
        this.sections.forEach(section => {
          // @ts-expect-error : generated method
          if (this.isDisplayed(section) && this.$refs[section] && this.$refs[section].allReadOnly && this.$refs[section].setFocus) {
            if (notifSection == section) {
              // @ts-expect-error : generated method
              this.$refs[section].setFocus(route);
              res = true;
            } else if (first == '') {
              first = section;
            }
          }
        })
        if (!res && first != '' && this.$refs[first]) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus(route);
        }
      }
    },

    // eslint-disable-next-line
    deliveryUpdated (delivery: Delivery) {
    // To implement
    },

    // eslint-disable-next-line
    transactionUpdated (transaction: Transaction) {
    // To implement
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isDisplayed (value: string): boolean {
      if ((!this.delivery || this.delivery.id < 0) && value == 'VIREMENT_DELIVERY_LIST') {
        this.setExtended(new Extended('VIREMENT_DELIVERY_LIST', this.fiche, true));
      }
      return true;
    }
  }
})
</script>
